<script>
    export let size = 24
    export let color = '#C5281C'
    export let style = ''
    export let title = null
</script>

<svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}`}
    height={`${size}`}
    {style}
    viewBox="0 0 512 512"
>
    {#if title}
        <title>{title}</title>
    {/if}
    <polyline
        points="196 220 260 220 260 392"
        style="fill:none;stroke:{color};stroke-linecap:round;stroke-linejoin:round;stroke-width:40px"
    ></polyline>
    <line
        x1="187"
        y1="396"
        x2="325"
        y2="396"
        style="fill:none;stroke:{color};stroke-linecap:round;stroke-miterlimit:10;stroke-width:40px"
    ></line>
    <path
        d="M256,160a32,32,0,1,1,32-32A32,32,0,0,1,256,160Z"
        style="fill:{color}"
    ></path>
</svg>
